import { useEffect, useState } from "react";

// Trailing-edge debounce for a rendered value, used to keep search-as-you-type
// from firing a query per keystroke.
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
